import loadable from '@loadable/component';

//const PrejectIdPage = loadable(() => import('./[projectId]/page'));
const ProjectsPage = loadable(() => import('./page'));
const ProjectsNew = loadable(() => import('./new/page'));

export const routes = [
  /*{
    path: ':id',
    element: <PrejectIdPage />,
  },*/
  {
    path: '',
    element: <ProjectsPage />,
  },
  {
    path: 'new',
    element: <ProjectsNew />,
  },
];
